<template>
  <div>
    <h4>Logo</h4>
    <b-card>
      <div style="display: inline-block" class="pb-3">
        <img :src="profile.logoUrl || ''" alt="Logo" style="width: 250px; height: 250px; object-fit: contain" />
      </div>
      <b-form-file accept="image/*" required v-model="fileInput" browse-text="Durchsuchen" placeholder="Keine Datei gewählt"></b-form-file>
      <b-button @click="uploadLogo">Hochladen</b-button>
    </b-card>
  </div>
</template>

<script>
import {uploadImage} from "@/storage/images";
import {mapState} from "vuex";

export default {
  props: ['value'],
  data() {
    return {
      fileInput: null
    }
  },
  computed: mapState('user', ['user', 'profile']),
  methods: {
    async uploadLogo(){
      try {
        const url = await uploadImage(this.fileInput, `public/${this.user.uid}`)
        this.$store.commit('user/setProfileUpdate', {logoUrl: url})
        await this.$store.dispatch('user/saveProfile')
      } catch {
        this.$bvModal.show('error-modal')
      }
    }
  }
}
</script>